import baseTheme from '../baseTheme';
var MuiTab = {
    root: {
        fontWeight: 700,
        letterSpacing: 1.2,
        maxWidth: 480,
        paddingLeft: baseTheme.spacing(2),
        paddingRight: baseTheme.spacing(2),
        '&': {
            minWidth: 'auto',
        },
        '&.Mui-selected': {
            color: baseTheme.palette.primary.main,
        },
        '&.Mui-disabled': {},
    },
};
export default MuiTab;
//# sourceMappingURL=MuiTab.js.map